// src/pages/Moderation/ModerationQueuePage/ui/QueueTabs/QueueTabs.tsx
import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import './QueueTabs.scss';

import { ModerationQueueTab } from 'pages/Moderation/ModerationQueue/model/types';
import { base } from 'routes/ModerationRoutes';

type Props = { activeTab: ModerationQueueTab };

export const QueueTabs: React.FC<Props> = ({ activeTab }) => {
  return (
    <div className="queue-tabs">
      <Link
        to={`${base}/queue/active`}
        className={classNames('queue-tabs__btn', 'queue-tabs__btn--left', {
          'queue-tabs__btn--active': activeTab === 'active',
        })}
      >
        Active
      </Link>

      <Link
        to={`${base}/queue/approve`}
        className={classNames('queue-tabs__btn', 'queue-tabs__btn--center', {
          'queue-tabs__btn--active': activeTab === 'approve',
        })}
      >
        Approve
      </Link>

      <Link
        to={`${base}/queue/reject`}
        className={classNames('queue-tabs__btn', 'queue-tabs__btn--right', {
          'queue-tabs__btn--active': activeTab === 'reject',
        })}
      >
        Reject
      </Link>
    </div>
  );
};
